import * as z from "zod";
import { generateMockFromSchema } from "./generate-mock-from-schema";
import { getMockResponse } from "./mock-storage";

interface RpcRegistration {
  outputSchema: z.ZodTypeAny;
  inlineMock?: unknown | ((generated: unknown) => unknown);
}

const registry = new Map<string, RpcRegistration>();

export function registerRpcSchema(
  name: string,
  outputSchema: z.ZodTypeAny,
  inlineMock?: unknown,
): void {
  registry.set(name, { outputSchema, inlineMock });
}

/** Returns the effective mock value for an RPC, in priority order:
 *  1. User-saved custom JSON (localStorage)
 *  2. Inline `mock` on the RPC definition
 *  3. Auto-generated from the output schema
 */
export async function resolveMockForRpc(name: string): Promise<unknown> {
  const custom = getMockResponse(name);
  if (custom !== undefined) {
    return custom;
  }

  const reg = registry.get(name);
  if (!reg) {
    return null;
  }

  const generated = generateMockFromSchema(reg.outputSchema, name);

  if (reg.inlineMock === undefined) {
    return generated;
  }
  if (typeof reg.inlineMock === "function") {
    return reg.inlineMock(generated);
  }
  return reg.inlineMock;
}

export function hasRegistration(name: string): boolean {
  return registry.has(name);
}
